import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/DashboardsContentViewQuery$parameters';

export const nav4DashboardsContentEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "nav4-dashboards-content-entry-point" */ './DashboardsContentViewQuery'
			).then(({ DashboardsContentViewQuery }) => DashboardsContentViewQuery),
		{ includeInShellOnlySsrBundle: true, entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (params: EntryPointRouteParams) => {
		const cloudId = params.tenantContext?.cloudId || '';

		return {
			queries: {
				queryRef: {
					parameters,
					variables: {
						cloudId,
					},
				},
			},
		};
	},
});
